<template>
    <div class="DM_transctionStatus" style="width: 30%;">
        <!-- 交易明细详情 -->
        <el-dialog :visible="statusIsShow" @close="handleClose" :close-on-click-modal="false" >
            <el-card class="box-card" shadow="hover">
                <div class="purseTitle">
                    <div>交易信息</div>
                </div>
                <el-row class="rowTitle">
                    <el-col :sm="24" :md="24" :lg="24">
                        <span class="labels">交易金额：</span>
                        <span>{{viewData.amount}}</span>
                    </el-col>
                    <el-col :sm="24" :md="24" :lg="24">
                        <span class="labels">到账金额：</span>
                        <span>{{viewData.pay_amount}}</span>
                    </el-col>
                    <el-col :sm="24" :md="24" :lg="24">
                        <span class="labels">出款状态：</span>
                        <span>{{status}}</span>
                    </el-col>
                    <el-col :sm="24" :md="24" :lg="24">
                        <span class="labels">交易时间：</span>
                        <span>{{viewData.create_time}}</span>
                    </el-col>
                </el-row>
            </el-card>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "DM_transactionStatus",
    props: {
        statusIsShow: {
            type: Boolean,
            default: false
        },
        detail: {
            type: Object
        }
    },
    data() {
        return {
            level:sessionStorage.getItem('level'),
            viewData: {},
            page: {
                currentPage: 1, //当前页码
                pageSize: 10, //条数
                total: 0  //总数
            },
            status: "出款成功",
            loading: true,
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        handleClose() {
            this.$emit('infoClose')
        },
        getData() {
            this.$api.post("transaction/d0_order_query", { order_id: this.detail.transaction_number,pay_type: this.detail.pay_types }, res => {
                let data = res.data;
                if (res.code == 0) {
                    this.viewData = data;
                    this.viewData.amount = Number(data.amount/100).toFixed(2);
                    this.viewData.pay_amount = Number(data.pay_amount/100).toFixed(2);
                    formatCard(data.state)
                    //渲染结束后取消加载
                    this.loading = false;
                } else {
                    this.$message.error(res.msg);
                    //渲染结束后取消加载
                    this.loading = false;
                }
            })
        },
        formatCard(row) {
            switch (row) {
                case 5:
                    this.status = '出款失败';
                    break;
                case 6:
                    this.status = '出款成功';
                    break;
                case 7:
                    this.status = '订单失败';
                    break;
                case 8:
                    this.status = '补录冻结';
                    break;
                case 10:
                    this.status = '增量冻结';
                    break;
                default:
                    this.status = '未知状态';
                    break;
            }
        },
    }
};
</script>

<style lang="scss" scope>
.DM_transctionStatus {
    .purseTitle {
        font-size: 12px;
        margin: 10px 0;
        color: #909399;
        :nth-child(1) {
            font-weight: 700;
            color: #7f7f7f;
            padding-left: 10px;
            border-left: 4px solid #909399;
        }
    }
    .rowTitle {
        color: #909399;
        font-size: 12px;
        .el-col {
            margin: 5px 0;
        }
        .labels {
            font-weight: 700;
        }
    }
}
</style>
